<template>
    <div class="formgrid grid p-fluid">
        <i class="fa fa-bars fa-lg icon-button ml-1 text-primary" title="Metas" @click.stop="abrirModal()">
        </i>
        <b-modal size="xl" v-model="mostrarModal" no-close-on-backdrop no-enforce-focus @show="">
            <div slot="modal-title">Meta da Consultoria - Convenio: {{ evento.idConvenio }}</div>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">CPF do Cliente</label>
                            <b-input-group>
                                <b-form-input v-mask="'###.###.###-##'" type="text" v-model="cpfCliente" disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Tipo do Cliente</label>
                            <b-form-select :options="tiposClientes" v-model="tipoCliente" optionLabel="descricao"
                                optionValue="codigo" disabled></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Código do Cliente</label>
                            <b-input-group>
                                <b-form-input type="number" v-model="codCliente" disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Início Atendimento</label>
                            <b-input-group>
                                <date-picker v-mask="'##/##/####'" placeholder="DD/MM/YYYY" v-model="inicioAtendimento"
                                    disabled>
                                </date-picker>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Final Atendimento</label>
                            <b-input-group>
                                <date-picker v-mask="'##/##/####'" placeholder="DD/MM/YYYY" v-model="finalAtendimento"
                                    disabled>
                                </date-picker>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Tipo</label>
                            <b-input-group>
                                <b-form-select :options="tipos" v-model="selectedTipo" optionLabel="descricao"
                                    optionValue="codigo" disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Abordagem</label>
                            <b-input-group>
                                <b-form-select :options="abordagens" v-model="abordagem" optionLabel="descricao"
                                    optionValue="codigo" disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label>CPF do Gestor Responsável</label>
                            <b-input-group>
                                <b-form-input v-mask="'###.###.###-##'" type="text" v-model="cpfResponsavel"
                                    disabled></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="4">
                        <b-form-group>
                            <label class="required">Carga Horária</label>
                            <b-input-group>
                                <b-form-input type="number" v-model="cargaHoraria" disabled></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="8">
                        <b-form-group>
                            <label class="required">Título</label>
                            <b-input-group>
                                <b-form-input type="text" v-model="tituloAtendimento" disabled></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label class="required">Projeto</label>
                            <b-input-group>
                                <!-- <b-spinner small></b-spinner> -->
                                <b-form-select :options="projeto" v-model="codProjeto" text-field="nomePratif"
                                    value-field="codPratif" @change="updateSelectedProjeto()" disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label class="required">Ação</label>
                            <b-input-group>
                                <b-form-select :options="acoes" v-model="codAcao" text-field="nomeAcao"
                                    value-field="codAcaoSeq" @change="updateSelectedAcao()" disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Instrumento</label>
                            <b-input-group>
                                <b-form-select :options="instrumentos" v-model="codInstrumento"
                                    text-field="descCategoria" value-field="codCategoria"
                                    @change="updateSelectedInstrumento()" disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Tema</label>
                            <b-input-group>
                                <b-form-select :options="tema" v-model="codTema" text-field="descAreaTematica"
                                    value-field="codAreaTematica" @input="updateSelectedTema()"
                                    disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Código de Realização</label>
                            <b-input-group>
                                <b-form-input type="number" v-model="codRealizacao" disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Tipo da Realização</label>
                            <b-input-group>
                                <b-form-input type="text" v-model="tipoRealizacao" disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="12">
                        <b-form-group>
                            <label class="text-nowrap required">Descrição do Atendimento</label>
                            <b-input-group>
                                <b-form-input type="text" v-model="descricaoAtendimento" disabled></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>


                </b-row>


            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
                <!-- <b-button variant="primary" :disabled="$v.$invalid" @click.stop="salvarInformacoesConsultoria()"
                    class="ml-1">
                    Salvar
                </b-button> -->
            </div>
            <b-card no-body>
                <b-card-header>
                    <span class="h5"> Metas da Consultoria </span>
                </b-card-header>
                <b-card-body>
                    <app-tabela :itens="metasConsultorias" :campos="campos" :itensPorPagina="itensPorPagina"
                        :bordered="false" :small="false">
                        <template slot="botoes">
                            <!-- <b-button-group class="float-right">
                                <b-button variant="success"  :disabled="$v.$invalid"
                                    @click="inserirMetaConsultoria()" class="ml-1">
                                    Inserir Meta da Consultoria
                                </b-button>
                            </b-button-group> -->
                        </template>

                        <template slot="acoes" slot-scope="data">
                            <span>
                                <b-button-group class="float-right" >
                                    <documentos-meta-consultoria 
                                    v-if="$temAcessoView('CONV-META-CONSUL-03')"
                                    :consultoria="data"
                                    @atualizarLista="atualizarConsultorias()">
                                    </documentos-meta-consultoria>
                                    <!-- <btn-cancelar-meta :evento="evento" :meta="data" :dataServicos="dataServicos"
                                        @fecharModal="fecharModal()"
                                        @abrirModal="abrirModal()">
                                    </btn-cancelar-meta> -->

                                </b-button-group>
                            </span>
                        </template>
                        <!-- <template slot="situacao" slot-scope="data">
                            <app-status :status="data.situacao.toUpperCase()"></app-status>
                        </template> -->
                    </app-tabela>
                </b-card-body>
            </b-card>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BtnCancelarMeta from './BtnCancelarMeta'
import BtnInserirMeta from './BtnInserirMeta'
import consultoriaServicos from './../ConsultoriasServicos'
import DocumentosMetaConsultoria from './../DocumentosMetaConsultoria'

export default {
    components: {
        BtnInserirMeta,
        BtnCancelarMeta,
        DocumentosMetaConsultoria
    },

    props: {
        evento: {
            type: Object,
            default: () => ({})
        },

        acao: {
            type: Object,
            default: () => ({})
        },



        permiteInserirMetas: {
            type: Boolean,
            default: false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: false
        }
    },

    validations: {
        cpfCliente: { required },
        codCliente: { required },
        tipoCliente: { required },
        inicioAtendimento: { required },
        finalAtendimento: { required },
        selectedTipo: { required },
        abordagem: { required },
        cargaHoraria: { required },
        tituloAtendimento: { required },
        tipoRealizacao: { required },
        descricaoAtendimento: { required },
        codRealizacao: { required },
        codTema: { required },
        codInstrumento: { required },
        codAcao: { required },
        codProjeto: { required }

    },

    data() {
        return {
            codInstrumento: null,
            quantidade: null,
            codAcao: null,
            codProjeto: null,
            codTema: null,
            cpfCliente: null,
            tipoCliente: null,
            codCliente: null,
            inicioAtendimento: null,
            finalAtendimento: null,
            abordagem: null,
            cpfResponsavel: null,
            cargaHoraria: null,
            metasConsultorias: null,
            tituloAtendimento: null,
            projeto: [],
            acoes: [],
            tipoRealizacao: "",
            nomeAcao: null,
            descricaoAcao: '',
            descricaoProjeto: '',
            descricaoInstrumento: '',
            codRealizacao: null,
            descricaoTema: '',
            acaoConsultoria: null,
            tema: [],
            descricaoAtendimento: null,
            consultoriaDto: null,
            idAcaoPlanoTrabalho: null,
            idConsultoria: null,
            totalPrevisto: null,
            totalRealizado: null,
            mostrarModal: false,
            erros: [],
            itensPorPagina: 5,
            metas: [],
            selectedTipo: 0,
            abordagens: [
                { value: 0, text: 'INDIVIDUAL' },
                { value: 1, text: 'GRUPAL' },
                { value: 2, text: 'UNIVERSAL' },
            ],
            tipos: [
                { value: 0, text: 'Consultoria Convênio Transferência' }
            ],
            instrumentos: [

            ],

            tiposClientes: [
                { value: 0, text: 'CNPJ' },
                { value: 1, text: 'CPF' }
            ],
            campos: [
                {
                    key: 'nomeMeta',
                    label: 'Nome da Meta',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'totalRealizado',
                    label: 'Total Realizado(Horas)',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ]
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            // this.obterProjetos();
            // this.obterInstrumentos();
            // this.obterAcoes();
            // this.obterTemas();
            if (this.evento.idConsultoria) {
                this.obterMetasConsultoria(this.evento.idConsultoria);
            }

        },
        updateSelectedAcao() {
            const selected = this.acoes.find(acao => acao.codAcaoSeq === this.codAcao);
            this.descricaoAcao = selected ? selected.nomeAcao : '';

        },
        updateSelectedProjeto() {
            const selected = this.projeto.find(acao => acao.codPratif === this.codProjeto);
            this.descricaoProjeto = selected ? selected.nomePratif : '';

        },
        updateSelectedTema() {
            const selected = this.tema.find(acao => acao.codAreaTematica === this.codTema);
            this.descricaoTema = selected ? selected.descAreaTematica : '';

        },
        updateSelectedInstrumento() {
            const selected = this.instrumentos.find(acao => acao.codCategoria === this.codInstrumento);
            this.descricaoInstrumento = selected ? selected.descCategoria : '';

        },
        obterProjetos() {

            //obterProjetos

            // this.$store.dispatch('addRequest')

            this.dataServicos.obterProjetosSas().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.projeto = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors)
                        }
                    }
                    // this.$store.dispatch('removeRequest')
                }
            )
        },
        obterMetasConsultoria(id) {
            consultoriaServicos.obterMetasConsultoria(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.metasConsultorias = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors)
                        }
                    }
                    // this.$store.dispatch('removeRequest')
                }
            )

        },
        obterAcoes() {
            // obterAcoes
            // this.$store.dispatch('addRequest')

            this.dataServicos.obterAcoesSas().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors);
                        }
                    }
                    //this.$store.dispatch('removeRequest') 
                }
            )
        },
        obterInstrumentos() {
            // obterTiposInstrumento
            //  this.$store.dispatch('addRequest')

            this.dataServicos.obterTiposInstrumento().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.instrumentos = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors)
                        }
                    }
                    // this.$store.dispatch('removeRequest')
                }
            )
        },
        obterTemas() {
            // obterTemas

            // this.$store.dispatch('addRequest')
            this.dataServicos.obterTemasSas().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.tema = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors)
                        }
                    }
                    //  this.$store.dispatch('removeRequest')
                }
            )
        },
        preencherModalConsultoria() {

            if (this.evento != null) {

                this.consultoriaDto = this.evento
                this.cpfCliente = this.evento.cpfCliente
                this.tipoCliente = this.evento.tipoCliente
                this.codCliente = this.evento.codCliente
                this.inicioAtendimento = new Date(this.evento.inicioAtendimento) ? this.$moment(this.evento.inicioAtendimento).format('DD/MM/YYYY') : " "
                this.finalAtendimento = new Date(this.evento.finalAtendimento) ? this.$moment(this.evento.finalAtendimento).format('DD/MM/YYYY') : " "
                this.abordagem = this.evento.abordagem
                this.cpfResponsavel = this.evento.cpfResponsavel
                this.cargaHoraria = this.evento.totalRealizado
                this.tituloAtendimento = this.evento.tituloAtendimento
                this.acaoConsultoria = this.evento.acao
                this.codTema = this.evento.codTema
                this.codAcao = this.evento.codAcao
                this.codInstrumento = this.evento.codInstrumento
                this.nomeAcao = this.evento.acao
                this.codProjeto = this.evento.codProjeto
                this.descricaoAtendimento = this.evento.descricaoAtendimento
                this.tema = [{
                    descAreaTematica: this.evento.tema ? this.evento.tema : "",
                    codAreaTematica: this.evento.codTema
                }]
                this.instrumentos = [{
                    descCategoria: this.evento.instrumento ? this.evento.instrumento : "",
                    codCategoria: this.evento.codInstrumento
                }]
                this.acoes = [{
                    nomeAcao: this.evento.acao ? this.evento.acao : "",
                    codAcaoSeq: this.evento.codAcao
                }]
                this.projeto = [{
                    nomePratif: this.evento.projeto ? this.evento.projeto : "",
                    codPratif: this.evento.codProjeto
                }]
                this.codRealizacao = this.evento.codRealizacao
                this.tipoRealizacao = this.evento.tipoRealizacao

            }

        },

        fecharModal() {
            this.mostrarModal = false
            this.consultoriaDto = null;
        },

        salvarInformacoesConsultoria() {

            this.$store.dispatch('addRequest')

            this.consultoriaDto.cpfCliente = this.cpfCliente ? this.cpfCliente.replace(/[^0-9]/g, '') : 0,
                this.consultoriaDto.tipoCliente = this.tipoCliente,
                this.consultoriaDto.codCliente = this.codCliente,
                this.consultoriaDto.inicioAtendimento = new Date(this.inicioAtendimento),
                this.consultoriaDto.finalAtendimento = this.finalAtendimento,
                this.consultoriaDto.abordagem = this.abordagem,
                this.consultoriaDto.cpfResponsavel = this.cpfResponsavel ? this.cpfResponsavel.replace(/[^0-9]/g, '') : 0,
                this.consultoriaDto.cargaHoraria = this.cargaHoraria,
                this.consultoriaDto.totalRealizado = this.cargaHoraria,
                this.consultoriaDto.tituloAtendimento = this.tituloAtendimento,
                this.consultoriaDto.acaoConsultoria = this.acaoConsultoria,
                this.consultoriaDto.codTema = this.codTema,
                this.consultoriaDto.codAcao = this.codAcao,
                this.consultoriaDto.codProjeto = this.codProjeto,
                this.consultoriaDto.codInstrumento = this.codInstrumento,
                this.consultoriaDto.acao = this.descricaoAcao ? this.descricaoAcao : this.evento.acao,
                this.consultoriaDto.tema = this.descricaoTema ? this.descricaoTema : this.evento.tema,
                this.consultoriaDto.projeto = this.descricaoProjeto ? this.descricaoProjeto : this.evento.projeto,
                this.consultoriaDto.instrumento = this.descricaoInstrumento ? this.descricaoInstrumento : this.evento.instrumento,
                this.consultoriaDto.descricaoAtendimento = this.descricaoAtendimento,
                this.consultoriaDto.codRealizacao = parseInt(this.$moment(Date.now()).format('DDMMYYYYMMHHSS'), 10)
            this.consultoriaDto.tipoRealizacao = this.tipoRealizacao,
                this.consultoriaDto.idConvenio = this.evento.idConvenio

            this.dataServicos.alterarConsultoria(this.consultoriaDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Consultoria atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })

            //Inserir no Historico Cliente no Sas
            this.$store.dispatch('addRequest')
            let mesAnoCompetencia = this.$moment(this.finalAtendimento).format('MM/YYYY');
            let HistoricoSasDto = {

                CodCliente: this.codCliente,
                CodEmpreendimento: 0,
                DataHoraInicioRealizacao: this.inicioAtendimento,
                DataHoraFimRealizacao: this.finalAtendimento,
                NomeRealizacao: this.tituloAtendimento,
                CodRealizacao: this.codRealizacao ? this.codRealizacao : 0,
                TipoRealizacao: this.tipoRealizacao ? this.tipoRealizacao : 0,
                CodRealizacaoComp: this.abordagem,
                Instrumento: this.descricaoInstrumento,
                Abordagem: this.abordagem == 0 ? "I"
                    : this.abordagem == 1 ? "G"
                        : this.abordagem == 2 ? "U"
                            : " ",
                DescRealizacao: this.descricaoAcao ? this.descricaoAcao : " ",
                CodProjeto: this.codProjeto,
                CodAcao: this.codAcao,
                MesAnoCompetencia: mesAnoCompetencia,
                CargaHoraria: this.cargaHoraria,
                CodSebrae: 17,
                CodTema: this.codTema,
                CodSistemaOrigem: 0, //0(zero) para não informar o CodSistemaOrigem 
                CpfResponsavel: this.cpfResponsavel ? this.cpfResponsavel.replace(/[^0-9]/g, '') : 0,

            }

            this.dataServicos.inserirHistoricoSas(HistoricoSasDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Historico inserido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })

        }

    }

}
</script>
